import React, { useEffect, useState } from "react";
import PointIcon from "../../Assets/imgNewUI/point-coin-2.png";
// import Account from "../../Assets/imgNewUI/Account.png";
// import credidCardImage from "../../Assets/imgNewUI/creditPlaceHolder.png";
import Loader from "../../Utility/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { onSaveIamge } from "../../Store/Slices/utilityReducer";
import viewpoints from "../../Assets/imgNewUI/viewpoints.png";
import { ApiConfigData, ClientPlatformCode, CustomFormatNumber, trackEvent, UserIdAndStatusData } from "../../Utility/Utility";
import MyIcon from "../../Assets/imgNewUI/rotate-right";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import SavingAccountIcon from "../../Assets/imgNewUI/debitcard.png";
import defaultCardImg from "../../Assets/imgNewUI/creditPlaceHolder.png";
import debitDefaultCardImg from "../../Assets/imgNewUI/debitPlaceHolder.png";

const CardModal = ({
  isOpen,
  setIsOpen,
  selectedCard,
  creditCards,
  selectCard,
  defaultCard,
  loading,
}) => {
  const translation = getTranslation();
  const dispatch = useDispatch();
  const clientMasterData = useSelector((state) => state.clientMasterReducer);
  const pointIcon = clientMasterData?.clientMasterData?.[0]?.pointIcon || '';
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const [defaultImageClientWiseData, setDefaultImageClientWiseData] = useState({});
  const apiconfig = ApiConfigData();
  const { clientCode: clientPlatformCode, platformCode } = ClientPlatformCode();
  const { userId, userStatus } = UserIdAndStatusData();

  // Parse defaultImageClientWise whenever apiconfig data arrives
  useEffect(() => {
    if (apiconfig && apiconfig.length > 0) {
      const defaultImageClientWise = apiconfig?.find(
        (data) => data?.paramsKey === "DefaultImageClientWise"
      )?.paramsValue;
      
      let parsedData = {};
      try {
        if (typeof defaultImageClientWise === "string") {
          parsedData = JSON.parse(defaultImageClientWise);
        } else if (typeof defaultImageClientWise === "object" && defaultImageClientWise !== null) {
          parsedData = defaultImageClientWise;
        }
      } catch (err) {
        console.error("❌ JSON parse error:", err, defaultImageClientWise);
        parsedData = {};
      }
      
      setDefaultImageClientWiseData(parsedData);
    }
  }, [apiconfig]);

  const capitalizeFirstLetter = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleCardSelection = (index, type, card, callApi, defaultCard, e) => {
    e && e.stopPropagation();
    sessionStorage.setItem("autoSelect", true);
    selectCard(index, type, card, callApi, defaultCard);
    if (!callApi) {
      dispatch(
        onSaveIamge({
          currentPoints: card?.pointBalance,
          currentBg: card?.imagelink,
          cardName: card.CardTypeName,
          totalPointBalance: card?.totalPointBalance,
        })
      );
    }
    trackEvent("default_card", {
      card_name: card?.CardTypeName,
      points: card?.pointBalance || 0,
      client_code: clientPlatformCode,
      platform_code: platformCode,
      user_id: userId,
      user_status: userStatus,
      page_url: window.location.href,
    });
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      setTimeout(() => {
        setOpen(false);
        setClosing(false);
      }, 300); // match the CSS transition duration
    } else {
      document.body.style.overflow = "auto";
      setTimeout(() => {
        setOpen(false);
        setClosing(false);
      }, 300); // match the CSS transition duration
    }
  }, [isOpen]);
  const finalCredicards = creditCards?.filter(
    (card) => card?.identifiertype === "1002"
  ).filter((card) => card?.status === "1");
  const finalDebitcards = creditCards?.filter(
    (card) => card?.identifiertype === "1001"
  ).filter((card) => card?.status === "1");

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setIsOpen(false);
      setClosing(false);
    }, 1000); // match the CSS transition duration
  }

  const switchAccountEnable = apiconfig?.find(
    (data) => data?.paramsKey === "switchAccountEnable"
  )?.paramsValue;

  // const switchAccountEnable = "1"


  return (
    <>
      {isOpen && (
        <div className={`fixed inset-0 z-50 ${closing ? "fade-out" : "fade-in"}`}>
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end pointer-events-auto">
            <div className={`cardBg w-full max-h rounded-t-3xl p-4 overflow-y-auto relative modal-content ${closing ? "slide-out-bottom" : "slide-in-bottom"}`}>
              <div className="flex pb-4 pt-2 justify-between items-center">
                <div className="fs-wh text-xxl">
                  {" "}
                  {translation?.YourProducts}
                </div>
                <button
                  onClick={() => handleClose()}
                  className="text-3xl font-medium text-black pr-1"
                >
                  &times;
                </button>
              </div>
              {loading ? (
                <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-75">
                  <Loader />
                </div>
              ) : (
                <div className="mt-2 space-y-2.5 max-h-[60vh] overflow-y-auto">
                  {/* {finalCredicards?.length ? (
                    <h3 className="text-sm font-semibold text-gray-500 mt">
                      {translation?.creditCards}
                    </h3>
                  ) : null} */}
                  {finalCredicards.map((card, index) => (
                    <div
                      key={index}
                      className={`card-item width ${(selectedCard?.index === card?.identifier && switchAccountEnable === "1") ? "selected" : ""}`}
                      onClick={switchAccountEnable !== "0" ? (e) => {
                        if (!card.showTryAgain && !card.viewpoints)
                          handleCardSelection(card?.identifier, "credit", card, false, selectedCard?.index === card?.identifier, e);
                      } : null}
                    >
                      <div className="flex items-center">
                        <img
                          onClick={switchAccountEnable !== "0" ? (e) =>
                            handleCardSelection(
                              card?.identifier,
                              "credit",
                              card,
                              false,
                              selectedCard?.index === card?.identifier,
                              e
                            )
                            : null}
                          src={card.backgroundcolor || defaultImageClientWiseData?.CreditCardImage}
                          alt={card.cardname}
                          title={card.cardname}
                          className="card-img-sz mr-4"
                          onError={(e) => (e.target.src = defaultImageClientWiseData?.CreditCardImage)}
                        />
                        <div>
                          <div
                            className="card-name"
                            title={capitalizeFirstLetter(card.CardTypeName)}
                          >
                            {capitalizeFirstLetter(card.CardTypeName).length >
                              12
                              ? capitalizeFirstLetter(
                                card.CardTypeName
                              )?.substring(0, 12) + "..."
                              : capitalizeFirstLetter(card.CardTypeName)}
                          </div>
                          <div
                            className="card-code"

                          >
                            ••{card.CardNoLast4Digit}
                          </div>
                        </div>
                      </div>

                      {card.showTryAgain ? (
                        <button
                          className="flex items-center justify-center py-3 px-3 bg-gradient-to-r rounded-full modal-try-again"
                          onClick={(e) =>
                            handleCardSelection(
                              card?.identifier,
                              "credit",
                              card,
                              true,
                              selectedCard?.index === card?.identifier,
                              e
                            )
                          }
                        >
                          <MyIcon />
                          <span className="view-points pl-1 modal-try-again-text">
                            {translation?.tryAgain}
                          </span>
                        </button>
                      ) : isNaN(card?.pointBalance) || card.showViewPoint ? (
                        <button
                          className="flex items-center justify-center py-3 px-3 bg-gradient-to-r rounded-full view-banner"
                          onClick={(e) =>
                            handleCardSelection(
                              card?.identifier,
                              "credit",
                              card,
                              true,
                              selectedCard?.index === card?.identifier,
                              e
                            )
                          }
                        >
                          <img
                            src={viewpoints}
                            alt={card.CardTypeName}
                            title={card.CardTypeName}
                            className="w-4 h-4"
                          />
                          <span className="view-points pl-2">
                            {" "}
                            {translation?.viewPoints}
                          </span>
                        </button>
                      ) : (
                        <div className="card-point font-medium text-sm flex items-center pointBalance">
                          {pointIcon && <div className="card-point-icon"><img src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${pointIcon}`} alt="Card not found" /></div>}
                          <div className={`card-points text-gradient ${!pointIcon ? "pl-2" : ""}`}>
                            {CustomFormatNumber(Math.floor(card?.pointBalance))}
                          </div>
                          {/* <span className="ml-1"> {translation?.pts}</span> */}
                        </div>
                      )}
                    </div>
                  ))}

                  {finalDebitcards.map((card, index) => (
                    <div
                      key={index}
                      className={`debit-card ${(selectedCard?.index === card?.identifier && switchAccountEnable === "1")
                        ? "selected"
                        : ""
                        }`}
                      onClick={switchAccountEnable !== "0" ? () => {
                        if (!card.showTryAgain && !card.viewpoints)
                          handleCardSelection(card?.identifier, "debit", card);
                      } : null}
                    >
                      <div className="flex items-center">
                        <img
                          src={defaultImageClientWiseData?.SavingCardImage}
                          alt={card?.cardname}
                          title={card?.cardname}
                          className="card-img-sz mr-4"
                          onError={(e) => (e.target.src = defaultImageClientWiseData?.SavingCardImage)}
                        />
                        <div>
                          <div className="debit-head ">

                            {" "}
                            {translation?.savingsAccount?.length > 10 ? translation?.savingsAccount.substring(0, 12) + "..." : translation?.savingsAccount}
                            {card.CardNoLast4Digit && <div className="card-code">
                              ••{card.CardNoLast4Digit}
                            </div>}
                          </div>
                        </div>
                      </div>
                      {card.showTryAgain ? (
                        <button
                          className="flex items-center justify-center py-3 px-3 bg-gradient-to-r rounded-full modal-try-again"
                          onClick={(e) =>
                            handleCardSelection(
                              card?.identifier,
                              "debit",
                              card,
                              true,
                              selectedCard?.index === card?.identifier,
                              e
                            )
                          }
                        >
                          <MyIcon />
                          <span className="view-points pl-1 modal-try-again-text">
                            {translation?.tryAgain}
                          </span>
                        </button>
                      ) : isNaN(card?.pointBalance) ||
                        card.showViewPoint ? (
                        <button
                          className="flex items-center justify-center py-3 px-3 bg-gradient-to-r rounded-full view-banner"
                          onClick={(e) =>
                            handleCardSelection(
                              card?.identifier,
                              "credit",
                              card,
                              true,
                              selectedCard?.index === card?.identifier,
                              e
                            )
                          }
                        >
                          <img
                            src={viewpoints}
                            alt={card.CardTypeName}
                            title={card.CardTypeName}
                            className="w-4 h-4"
                          />
                          <span className="view-points pl-2">
                            {" "}
                            {translation?.viewPoints}
                          </span>
                        </button>
                      ) : (
                        <div className="card-point font-medium text-sm flex items-center pointBalance">
                          {pointIcon && <div className="card-point-icon"><img src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${pointIcon}`} alt="Card not found" /></div>}
                          <div className={`card-points text-gradient ${!pointIcon ? "pl-2" : ""}`}>
                            {CustomFormatNumber(
                              Math.floor(card?.pointBalance)
                            )}
                            {/* <span className="ml-1">{translation?.pts}</span> */}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CardModal;
